import { Injectable } from '@angular/core';
import { EnumDataset } from '../../../core/enums/enum-dataset';

@Injectable({
  providedIn: 'root',
})
export class DashbordService {
  constructor() {}

  preenchimentoDataSet() {
    EnumDataset.dataSetLogin;
  }
}
